import { render } from "./App.vue?vue&type=template&id=278dbc32&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=278dbc32&lang=css"

import exportComponent from "C:\\Paii\\Projects\\TT Exclusive\\ttex_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__